import axios from "axios";
import moment from "moment";
import { API_HOST } from "@/core/variables";
import { StatCounts, UserSentenceStatistics, ApiResponse, Page } from "@/model";
import { getUtcZeroTime, UTCToLocalString } from "@/util/dateUtil";

class StatisticsRepository {
    getStatCounts = (agentId: number, start: string, end: string) => {
        return axios.get<ApiResponse<StatCounts>>(`${API_HOST}/v1/agents/${agentId}/statistics/counts`, {
            params: {
                start: getUtcZeroTime(moment(start), "YYYY-MM-DD HH:mm:ss"),
                end: getUtcZeroTime(moment(end), "YYYY-MM-DD HH:mm:ss")
            }
        });
    };

    getUserSentences = (agentId: number, start: string, end: string) => {
        return axios.get<ApiResponse<UserSentenceStatistics[]>>(`${API_HOST}/v1/agents/${agentId}/statistics/sentences/all`, {
            params: {
                started: getUtcZeroTime(moment(start), "YYYY-MM-DD HH:mm:ss"),
                ended: getUtcZeroTime(moment(end), "YYYY-MM-DD HH:mm:ss")
            }
        });
    };

    getUserSentencePage = (
        agentId: number,
        startDate: string,
        endDate: string,
        sortKey: string,
        sortOrder: string,
        page: number,
        size: number
    ) => {
        return axios.get<ApiResponse<Page<UserSentenceStatistics>>>(`${API_HOST}/v1/agents/${agentId}/statistics/sentences/paginate`, {
            params: {
                started: getUtcZeroTime(moment(startDate), "YYYY-MM-DD HH:mm:ss"),
                ended: getUtcZeroTime(moment(endDate), "YYYY-MM-DD HH:mm:ss"),
                sort_key: sortKey,
                sort_order: sortOrder,
                page: page,
                size: size
            }
        });
    };

    getUserSentencesByIntent = (agentId: number, startDate: Date, endDate: Date, intentId?: string) => {
        const start = UTCToLocalString(startDate.toUTCString(), "YYYY-MM-DD HH:mm:ss");
        const end = UTCToLocalString(endDate.toUTCString(), "YYYY-MM-DD HH:mm:ss");
        return axios.get<ApiResponse<UserSentenceStatistics[]>>(`${API_HOST}/v1/agents/${agentId}/statistics/sentences`, {
            params: {
                intent_id: intentId,
                started: getUtcZeroTime(moment(start), "YYYY-MM-DD HH:mm:ss"),
                ended: getUtcZeroTime(moment(end), "YYYY-MM-DD HH:mm:ss")
            }
        });
    };

    exportUserSentences = (agentId: number, start: string, end: string) => {
        window.open(`${API_HOST}/v1/agents/${agentId}/statistics/export?started=${start}&ended=${end}`);
    };
}

const statisticsRepository = new StatisticsRepository();
export default statisticsRepository;